import React from 'react';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import MultiSelectBadge from './MultiSelectBadge';

interface FilterSelectProps {
  label: string;
  placeholder: string;
  selectedValues: string[];
  options: { value: string; label: string; id: string }[];
  onSelectChange: (value: string) => void;
  onRemoveValue: (value: string) => void;
  isMulti?: boolean;
  value?: string;
  disabled?: boolean;
}

const FilterSelect: React.FC<FilterSelectProps> = ({
  label,
  placeholder,
  selectedValues,
  options,
  onSelectChange,
  onRemoveValue,
  isMulti = true,
  value,
  disabled = false,
}) => {
  const getLabelForValue = (val: string) => {
    const option = options.find(opt => opt.value === val);
    return option ? option.label : val;
  };

  return (
    <div>
      <Label htmlFor={label.toLowerCase()}>{label}:</Label>
      {isMulti && (
        <div className="flex flex-wrap mb-2 min-h-6">
          {selectedValues.map((val) => (
            <MultiSelectBadge
              key={val}
              value={getLabelForValue(val)}
              onRemove={() => onRemoveValue(val)}
            />
          ))}
        </div>
      )}
      <Select
        value={isMulti ? undefined : value}
        onValueChange={onSelectChange}
        disabled={disabled}
      >
        <SelectTrigger>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default FilterSelect;
